import React from 'react';
import styles from './EventTitle.module.scss';

type EventTitleProps = {
  title: string;
};

export const EventTitle: React.FC<EventTitleProps> = ({ title }) => {
  if (!title) {
    return;
  }
  return (
    <h1 className={styles.wrapper} data-testid="event-title">
      {title}
    </h1>
  );
};
